import React from 'react';

import { Box, Paragraph } from '@zillow/constellation-10';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export const MAX_TENANTS = 8;

function TenantInformation_v3({ section, setSection, setSectionValues }: Props) {
  return (
    <>
      <Paragraph textStyle="body-lg-bold">Tell us about your tenants</Paragraph>
      <Paragraph css={{ marginBottom: 'layout.tight' }}>
        Add each tenant’s Zillow account email for signing the lease ({MAX_TENANTS} max).
      </Paragraph>
      <Box css={{ marginBottom: 'layout.tight' }}>
        <PeopleInformation
          isOptional={false}
          maximumPeople={MAX_TENANTS}
          personType={PERSON_TYPE.TENANT}
          setSectionValues={setSectionValues}
          setSection={setSection}
          section={section}
          addressLabel="Address for receiving notices prior to the lease’s start date"
        />
      </Box>
    </>
  );
}

TenantInformation_v3.description = `Basic TenantInformation component that limits total tenants to ${MAX_TENANTS}. Self upload version.`;

export default TenantInformation_v3;
